import { render } from "./KidCard.vue?vue&type=template&id=4212293a"
import script from "./KidCard.vue?vue&type=script&lang=js"
export * from "./KidCard.vue?vue&type=script&lang=js"

import "./KidCard.vue?vue&type=style&index=0&id=4212293a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__